import styled from "styled-components";
import {getCssSizeValue} from "@/utils/utils";

const Wrapper = styled.div`
	position: relative;
	background: ${({theme}) => theme.colors.platinum};
	max-height: ${getCssSizeValue(88)};

	.header {
		padding-top: ${getCssSizeValue(13)};
		padding-left: ${getCssSizeValue(16)};
		margin-bottom: ${getCssSizeValue(14)};
	}
	
	.date {
        padding-bottom: ${getCssSizeValue(8)};
        padding-left: ${getCssSizeValue(32)};
	}
`

export default function DateContainer({ date, header, className }) {
	return (
		<Wrapper className={`${className} date-container`}>
			<div className='header typo-borna typo-borna-12'>{header}</div>
			<div className='date typo-strawford typo-strawford-87'>{date}</div>
		</Wrapper>
	)
}